import { createStore } from 'vuex'
import megaMenu from "./mega-menu";
import mobileMenu from './mobile-menu'
import millionScoreCampaign from './million-score-campaign'
import alertStore from '@/store/alert/alert.store'
export const store =  createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    megaMenu: megaMenu,
    mobileMenu : mobileMenu,
    millionScoreCampaign :millionScoreCampaign,
    alert: alertStore
  }
})

export default store;
